import React, { useCallback } from "react";
import { Image, Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "./InstitutionForm.form";
import { InstitutionApi } from "../../../../../api";
import { useAuth } from "../../../../../hooks";
import { image } from "../../../../../assets";
import { useDropzone } from "react-dropzone";

const institutionController = new InstitutionApi();

export function InstitutionForm(props) {
  const { close, onReload, user, institution } = props;
  const { accessToken } = useAuth();
  const planOptions = [
    { key: "standar", value: "standar", text: "Plan Estandar" },
    { key: "maker", value: "maker", text: "Plan Educa360 Creador" },
    { key: "center", value: "center", text: "Plan Educa360 Centro" },
  ];

  const formik = useFormik({
    initialValues: initialValues(user, institution, !institution),
    validationSchema: validationSchema(institution),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!institution) {
          await institutionController.createInstitution(accessToken, formValue);
        } else {
          if (formik.values.fileAvatar && institution.avatar) {
            await institutionController.deleteAvatar(
              accessToken,
              institution.avatar,
            );
          }
          console.log("actualizar formValue", formValue);
          await institutionController.updateInstitution(
            accessToken,
            institution._id,
            formValue,
          );
        }

        onReload();
        close();
      } catch (error) {
        console.error("Error during form submission:", error);
      }
    },
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const validMimeTypes = ["image/jpeg", "image/png"];
        if (validMimeTypes.includes(file.type)) {
          formik.setFieldValue("avatar", URL.createObjectURL(file));
          formik.setFieldValue("fileAvatar", file);
        } else {
          console.error("Invalid file format or type.");
        }
      }
    },
    [formik],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    onDrop,
    multiple: false,
  });

  const getAvatar = () => {
    if (formik.values.fileAvatar) {
      return formik.values.avatar;
    } else if (formik.values.avatar) {
      return `${formik.values.avatar}`;
    }
    return image.noAvatar;
  };

  return (
    <Form className="user-form" onSubmit={formik.handleSubmit}>
      <div className="user-form__avatar" {...getRootProps()}>
        <input {...getInputProps()} />
        <Image avatar size="small" src={getAvatar()} />
      </div>
      <Form.Field>
        <label>ID del Partner</label>
        <span>{formik.values.partnerId}</span>
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          name="institutionnam"
          placeholder="Nombre de la institución"
          onChange={formik.handleChange}
          value={formik.values.institutionnam}
          error={formik.errors.institutionnam}
        />
      </Form.Group>

      <Form.Input
        name="address"
        placeholder="Dirección"
        onChange={formik.handleChange}
        value={formik.values.address}
        error={formik.errors.address}
      />
      <Form.Group widths="equal">
        <Form.Input
          name="city"
          placeholder="Ciudad"
          onChange={formik.handleChange}
          value={formik.values.city}
          error={formik.errors.city}
        />
        <Form.Input
          name="country"
          placeholder="Región"
          onChange={formik.handleChange}
          value={formik.values.country}
          error={formik.errors.country}
        />
      </Form.Group>

      <Form.Input
        name="website"
        placeholder="Web"
        onChange={formik.handleChange}
        value={formik.values.website}
        error={formik.errors.website}
      />
      <Form.Group widths="equal">
        <Form.Input
          name="phone"
          placeholder="Teléfono"
          onChange={formik.handleChange}
          value={formik.values.phone}
          error={formik.errors.phone}
        />
        <Form.Dropdown
          placeholder="Selecciona el plan"
          options={planOptions}
          selection
          onChange={(e, data) => formik.setFieldValue("plan", data.value)}
          value={formik.values.plan}
          error={formik.errors.plan}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Input
          name="firstname"
          placeholder="Nombre"
          onChange={formik.handleChange}
          value={formik.values.firstname}
          error={formik.errors.firstname}
        />
        <Form.Input
          name="lastname"
          placeholder="Apellidos"
          onChange={formik.handleChange}
          value={formik.values.lastname}
          error={formik.errors.lastname}
        />
      </Form.Group>
      <Form.Group>
        <Form.Input
          name="studentsnum"
          placeholder="Licencias de estudiantes"
          onChange={formik.handleChange}
          value={formik.values.studentsnum}
          error={formik.errors.studentsnum}
        />
        <Form.Input
          name="teachersnum"
          placeholder="Licencias de profesores"
          onChange={formik.handleChange}
          value={formik.values.teachersnum}
          error={formik.errors.teachersnum}
        />
      </Form.Group>

      <Form.Input
        name="email"
        placeholder="Correo electrónico"
        onChange={formik.handleChange}
        value={formik.values.email}
        error={formik.errors.email}
        autoComplete="off"
      />

      <Form.Input
        type="password"
        name="password"
        placeholder="Contraseña"
        onChange={formik.handleChange}
        value={formik.values.password}
        error={formik.errors.password}
        autoComplete="new-password"
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {institution ? "Actualizar usuario" : "Crear usuario"}
      </Form.Button>
    </Form>
  );
}
